import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "PlaybackRewind.svg",
  "use": "PlaybackRewind.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"PlaybackRewind.svg\"><path d=\"M29.0222,44.7359l-17.9934-10.92a2.12,2.12,0,0,1,0-3.5874l17.9934-10.92a1.9968,1.9968,0,0,1,3.0014,1.7938v8.5231L49.0222,19.3075a1.9968,1.9968,0,0,1,3.0014,1.7938v21.841a1.9967,1.9967,0,0,1-3.0014,1.7936L32.0236,34.419v8.5233A1.9967,1.9967,0,0,1,29.0222,44.7359Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol